import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";

//----- store
import { fetchCatalogData } from "../store/CoursesCatalog-actions";

import FormCatalogFilter from "../components/FormCatalogFilter/FormCatalogFilter";
import CardImageAndText from "../components/CardImageAndText/CardImageAndText";

import LoadingSpinner from "../components/UI/LoadingSpinner/LoadingSpinner";

import Styles from "./CoursesCatalog.module.css";

const CoursesCatalog = () => {
	const dispatch = useDispatch();
	const [catalogCoursesDataLoaded, setCatalogCoursesDataLoaded] =
		useState(false);

	const isLoading = useSelector((state) => state.uiData.isLoading[10]);
	const apiConfigData = useSelector((state) => state.apiConfigData);
	const CoursesCatalogData = useSelector((state) => state.CoursesCatalogData);
	const autenticationData = useSelector(
		(state) => state.uiData.autentication
	);

	const url_data =
		apiConfigData.endpoint.domain + apiConfigData.endpoint.coursesCatalog;

	const filterData = (filterData) => {
		console.log(filterData);

		let filterString = "?";

		for (var key in filterData) {
			var value = filterData[key];
			if (value) {
				// console.log(key + ": " + value)
				filterString += "&" + key + "=" + value;
			}
		}

		console.log(filterString);

		dispatch(fetchCatalogData(url_data + filterString, autenticationData));
	};

	useEffect(() => {
		dispatch(fetchCatalogData(url_data, autenticationData));
	}, [dispatch]);

	useEffect(() => {
		console.log("CoursesCatalogData", CoursesCatalogData);
		// console.log("CoursesCatalogData", CoursesCatalogData);
		// if(){
		// 	setCatalogCoursesDataLoaded
		// }
	}, [CoursesCatalogData]);

	return (
		<div className={Styles["CoursesCatalog"]} style={{ color: "#ededed" }}>
			<div className={`container ${Styles["container"]}`}>
				<div className={"row"}>
					<div
						className={"col-xs-12 title"}
					>{`Catálogo (${CoursesCatalogData.catalogData.length})`}</div>
				</div>
			</div>
			<div className={Styles["full-container"]}>
				<div className={`container ${Styles["container"]}`}>
					<div className={"row"}>
						<div className={"col-xs-12"}>
							<div className={"row"}>
								<div
									className={`col-xs-12 ${Styles["col-padding"]}`}
								>
									<FormCatalogFilter
										filterData={filterData}
									/>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div className={`container ${Styles["container"]}`}>
				<div className={"row"}>
					{!isLoading &&
						CoursesCatalogData.catalogData.map((row) => (
							<CardImageAndText
								key={row.id}
								sector={row.catalogNode.nome}
								title={row.name}
								hours={row.durationSpan}
								id={row.id}
								trainingType={row.trainingType}
								school={row.subSite.name}
								img={row.base64Image}
								btn="Ver mais"
								ratingEval={row.ratingEval}
							/>
						))}
				</div>
				{isLoading && (
					<div style={{ textAlign: "center" }}>
						<LoadingSpinner />
					</div>
				)}
				{CoursesCatalogData.catalogData.length == 0 && (
					<div className={Styles["no-record-found"]}>
						Não foi encontrado nenhum registo
					</div>
				)}
			</div>
		</div>
	);
};

export default CoursesCatalog;
